import type { TFunction } from 'i18next';

type Cell = {
  /** 번역 키(한국어 원문). 없으면 빈 입력칸 */
  label?: string;
  head?: boolean;
  colspan?: number;
  rowspan?: number;
};

const CELL =
  'height:20px;padding:0px 3px;vertical-align:middle;border:1px solid #000000;';
const HEAD_CELL = `${CELL}background-color:#d9d9d9;font-weight:bold;text-align:center;`;

const head = (label: string, colspan = 1, rowspan = 1): Cell => ({
  label,
  head: true,
  colspan,
  rowspan,
});
const blank = (colspan = 1, rowspan = 1): Cell => ({ colspan, rowspan });
const blankHead = (colspan = 1): Cell => ({ head: true, colspan });

/** 레거시 appr_sub_view_forms_shopopen(stype=1) — 섹션 제목과 8칸 표 */
const SECTIONS: { title?: string; rows: Cell[][] }[] = [
  {
    title: '기본정보',
    rows: [
      [head('브랜드', 2), blank(2), head('거래형태', 2), blank(2)],
      [head('매장명(지역)', 2), blank(2), head('출고율', 2), blank(2)],
      [head('오픈일', 2), blank(2), head('결제방법', 2), blank(2)],
    ],
  },
  {
    title: '담보조건',
    rows: [
      [
        head('현금보증금', 1, 2),
        head('부동산', 3),
        head('보증보험', 1, 2),
        head('기타담보', 3, 2),
      ],
      [head('물건종류'), head('설정액'), head('당사담보순위')],
      [blank(), blank(), blank(), blank(), blank(), blank(3)],
      [head('기타의견'), blank(7)],
    ],
  },
  {
    title: '매장현황',
    rows: [
      [head('위치'), blank(2), head('상호명'), blank(2), head('평수'), blank()],
      [
        head('점주'),
        blank(2),
        head('최종근무지'),
        blank(2),
        head('비고'),
        blank(),
      ],
    ],
  },
  {
    title: '매출목표',
    rows: [
      [{ label: '(단위: 원)', colspan: 8 }],
      [head('S/S', 2), head('F/W', 2), head('TOTAL', 2), head('비고', 2, 2)],
      [
        head('시즌목표'),
        head('월평균'),
        head('시즌목표'),
        head('월평균'),
        head('목표'),
        head('월평균'),
      ],
      [blank(), blank(), blank(), blank(), blank(), blank(), blank(2)],
      [head('본사지원사항', 2), blank(6)],
    ],
  },
  {
    title: 'B.E.P',
    rows: [
      [{ label: '(단위: 원)', colspan: 8 }],
      [blankHead(3), head('금액(월평균)', 3), head('비고', 2)],
      [head('이자비용(보증금, 권리금)', 3), blank(3), blank(2)],
      [head('경비(인건비, 기타세금)', 3), blank(3), blank(2)],
      [head('월임대료', 3), blank(3), blank(2)],
      [head('감가상각(인테리어, 집기)', 3), blank(3), blank(2)],
      [head('손익분기점 매출', 3), blank(3), blank(2)],
    ],
  },
  {
    rows: [[head('업무협조사항', 2), blank(6)]],
  },
];

/** 번역하지 않는 고정 문구 */
const UNTRANSLATED = new Set(['S/S', 'F/W', 'TOTAL', 'B.E.P']);

/** (구)매장 OPEN 품의(8) 대리점 양식 — 레거시처럼 빈 표를 본문에 넣고 직접 입력. 작성자 언어로 채움 */
export const buildStoreOpenAgencyContent = (t: TFunction): string => {
  const text = (label: string) =>
    UNTRANSLATED.has(label) ? label : t(label, { nsSeparator: false });
  const cols = Array.from({ length: 8 }, () => '<col width="75">').join('');
  return SECTIONS.map(({ title, rows }) => {
    const body = rows
      .map(
        (cells) =>
          `<tr style="height:20px;">${cells
            .map(
              ({ label, head: isHead, colspan = 1, rowspan = 1 }) =>
                `<td colspan="${colspan}" rowspan="${rowspan}" style="${
                  isHead ? HEAD_CELL : CELL
                }">${label ? text(label) : ''}</td>`,
            )
            .join('')}</tr>`,
      )
      .join('');
    return [
      title ? `<h4><strong>${text(title)}</strong></h4>` : '',
      `<table cellspacing="0" cellpadding="0" style="table-layout:fixed;font-size:13px;"><colgroup>${cols}</colgroup><tbody>${body}</tbody></table>`,
      '<p><br></p>',
    ].join('');
  }).join('');
};
